import React from 'react'
import PropTypes from 'prop-types'
import Radio from '../../../form/component/Radio'
import Input from '../../../form/component/Input'


const Midline = ({ existingCondition, changeExistingCondition, valuePrefix, title, readOnly, saveTreatmentPlan }) => {
    const onChange = (name, value) => {
        changeExistingCondition(name, value)
        saveTreatmentPlan()
    }
    return (
        <div>
            <b>{title}</b>
            <div className="mid-line">
                <div className="mid-line-radio">
                    <Radio
                        name={valuePrefix + 'MidlineValue'}
                        value="centered"
                        object={existingCondition}
                        onChange={onChange}
                        readOnly={readOnly}
                    >&#160;centered
                    </Radio>
                </div>
            </div>
            <div className="mid-line">
                <div className="mid-line-radio">
                    <Radio
                        name={valuePrefix + 'MidlineValue'}
                        value="shifted_right"
                        object={existingCondition}
                        onChange={onChange}
                        readOnly={readOnly}
                    >&#160;shifted right
                    </Radio>
                </div>
                <div className="mid-line-input">
                    <Input
                        type="number"
                        name={valuePrefix + 'MidlineShiftedRight'}
                        object={existingCondition}
                        placeholder="mm"
                        readOnly={readOnly}
                        onChange={changeExistingCondition}
                        onBlur={saveTreatmentPlan}/>
                </div>
            </div>
            <div className="mid-line">
                <div className="mid-line-radio">
                    <Radio
                        name={valuePrefix + 'MidlineValue'}
                        value="shifted_left"
                        object={existingCondition}
                        onChange={onChange}
                        readOnly={readOnly}
                    >&#160;shifted left
                    </Radio>
                </div>
                <div className="mid-line-input">
                    <Input
                        type="number"
                        name={valuePrefix + 'MidlineShiftedLeft'}
                        object={existingCondition}
                        placeholder="mm"
                        readOnly={readOnly}
                        onChange={changeExistingCondition}
                        onBlur={saveTreatmentPlan}/>
                </div>
            </div>
        </div>
    )
}

Midline.propTypes = {
    existingCondition: PropTypes.object.isRequired,
    changeExistingCondition: PropTypes.func.isRequired,
    valuePrefix: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
}

export default Midline



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/Midline.js